import React, { forwardRef, useMemo } from 'react'
import { FieldTypes, urlRegexValidator, emailValidator } from 'utils/formUtils';
import MendIOMappingForm from './MendIOMappingForm';
import GenericPullCredentialsForm from '../GenericPullCredentialsForm';
import { Alert } from 'antd';

function MendIOCredentialsForm(props, ref) {
    const fields = useMemo(() => (
        [{
            name: "apiEndpoint",
            label: "API Endpoint",
            rules: [urlRegexValidator],
            required: true
        },{
            name: "email",
            label: "Email",
            rules: [emailValidator],
            required: true
        },
        {
            name: "userKey",
            label: "User Key",
            type: FieldTypes.PASSWORD,
            required: true
        }, {
            name: "orgToken",
            label: "Org Token",
            type: FieldTypes.PASSWORD,
            required: true
        }, {
            name: "message",
            type: FieldTypes.LABEL,
            value: <Alert type='warning' message="Projects for this integration will be available after few minutes of adding the credentials, since they are pulled in background." />
        }]
    ), [])

    return (
        <GenericPullCredentialsForm
            {...props}
            ref={ref}
            fields={fields}
            initialValue={{ apiEndpoint: "https://api-saas.whitesourcesoftware.com" }}
            config={props.config && { apiEndpoint: "https://api-saas.whitesourcesoftware.com", ...props.config }}
            MappingForm={MendIOMappingForm}
        />
    )
}

export default forwardRef(MendIOCredentialsForm);